import React from 'react';

interface BottomNavProps {
  currentView: string;
  goToDashboard: () => void;
  setSidebarOpen: (open: boolean) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ 
  currentView, 
  goToDashboard, 
  setSidebarOpen 
}) => {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '70px',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid #e5e7eb',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 1000,
      paddingBottom: 'env(safe-area-inset-bottom)', // Support for notch phones
      boxShadow: '0 -4px 12px rgba(0,0,0,0.05)'
    }}>
      <button 
        onClick={goToDashboard}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'none',
          border: 'none',
          color: currentView === 'dashboard' ? '#22c55e' : '#6b7280',
          gap: '4px',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontSize: '24px' }}>🏠</span>
        <span style={{ fontSize: '10px', fontWeight: '600' }}>Home</span>
      </button>

      <button 
        onClick={() => {
          goToDashboard();
          // Small delay to ensure we are on dashboard before scrolling
          setTimeout(() => {
             window.scrollTo({ top: 400, behavior: 'smooth' });
          }, 100);
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'none',
          border: 'none',
          color: currentView === 'topics' ? '#22c55e' : '#6b7280',
          gap: '4px',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontSize: '24px' }}>📚</span>
        <span style={{ fontSize: '10px', fontWeight: '600' }}>Subjects</span>
      </button>

      <button 
        onClick={() => setSidebarOpen(true)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'none',
          border: 'none',
          color: '#6b7280',
          gap: '4px',
          cursor: 'pointer'
        }}
      >
        <div style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          background: '#22c55e',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '20px',
          marginTop: '-30px', // Lifted button effect
          boxShadow: '0 4px 10px rgba(34, 197, 94, 0.4)',
          border: '4px solid white'
        }}>
          ☰
        </div>
        <span style={{ fontSize: '10px', fontWeight: '600', marginTop: '2px' }}>Menu</span>
      </button>

      <button 
        onClick={() => {
          // If we had a progress view, we'd go there. For now, go to dashboard.
          goToDashboard();
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'none',
          border: 'none',
          color: '#6b7280',
          gap: '4px',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontSize: '24px' }}>📈</span>
        <span style={{ fontSize: '10px', fontWeight: '600' }}>Progress</span>
      </button>

      <button 
        onClick={() => {
           // Reload to selection screen (basically clearing grade)
           window.location.search = '';
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'none',
          border: 'none',
          color: '#6b7280',
          gap: '4px',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontSize: '24px' }}>⚙️</span>
        <span style={{ fontSize: '10px', fontWeight: '600' }}>Settings</span>
      </button>
    </div>
  );
};
